import { runInAction } from "mobx";
import { dashboardService } from "../services/dashboard.service";
import { dashboardFiltersStore } from "../stores/filters.store";
import { dashboardDataTableStore } from "../stores/data-table.store";
import { dashboardEsgDataTableStore } from "../stores/esg-data-table.store";
import { dashboardOverviewStore } from "../stores/target-data-overview.store";
import { resolveSelectedReportingPeriod } from "../utils/reporting-years";

// The picker emits country ids prefixed with "country:" (synthetic ids
// the API never sees). The endpoint accepts raw country names.
const stripCountryPrefix = (id) =>
  typeof id === "string" && id.startsWith("country:")
    ? id.slice("country:".length)
    : String(id);

export const loadEsgDataTable = async () => {
  const store = dashboardEsgDataTableStore;
  const { view, filters, cleared } = dashboardDataTableStore;
  const { frameworks } = dashboardFiltersStore.filters;
  const { page, pageSize, sort } = store;

  if (view !== "year" && filters.years.length === 0) {
    store.setResult({
      rows: [],
      total: 0,
      totalPages: 0,
      page: 1,
      pageSize: store.pageSize,
    });
    return;
  }

  // Any explicitly-cleared filter means "nothing selected" → empty result.
  if (
    cleared?.years ||
    cleared?.bus ||
    cleared?.countries ||
    cleared?.categories
  ) {
    store.setResult({
      rows: [],
      total: 0,
      totalPages: 0,
      page: 1,
      pageSize: store.pageSize,
    });
    return;
  }

  const seq = store.nextRequestSeq();
  store.setLoading(true);
  try {
    const reportingPeriod = resolveSelectedReportingPeriod(
      filters.years,
      dashboardFiltersStore.available.reportingYears,
    );
    const data = await dashboardService.getEsgDataTable({
      groupBy: view,
      years: filters.years,
      ...(reportingPeriod || {}),
      bus: filters.bus,
      countries: filters.countries.map(stripCountryPrefix),
      frameworks,
      categories: filters.categories,
      search: dashboardOverviewStore.search,
      page,
      pageSize,
      sortBy: sort.by,
      sortKey: stripCountryPrefix(sort.key),
      sortDirection: sort.direction,
    });
    if (store.isStaleSeq(seq)) return;
    runInAction(() => {
      store.setResult(data);
    });
  } finally {
    if (!store.isStaleSeq(seq)) store.setLoading(false);
  }
};
